import React from 'react'
import { Box, Typography } from "@mui/material";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import SingleTeamInfoModal from "../../Components/Shared/SingleTeamInfoModal";
import { useState } from "react";
import { teamData } from "../../Components/Shared/OurTeamData";


const ManagementTeam = () => {
  const [selectedMember, setSelectedMember] = useState(null);
  const [open, setOpen] = useState(false);

  const handleOpen = (member) => {
    setSelectedMember(member);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedMember(null);
  }
  return (
    <>
      <Box className="managementTeam">
        <Container>
          <Row>
            <Box className="text-fuse relative">
              <Typography variant="h1" className="londrina-" >Meet our</Typography>
              <Typography variant="h2" className="londrin" >management Team</Typography>
            </Box>
              {teamData.map((member, index) => (
                <Col className="" lg={4} md={6} sm={12} >
                  <Box key={index} className="teamCard" onClick={() => handleOpen(member)}>
                    <Box className="teamCardContent">
                        <Image src={member.image} alt="team" style={{ borderRadius:'12px' }}  className="img-fluid" />
                        <Link variant="h2">{member.name}</Link>
                        <Typography variant="subtitle1" className="designation">{member.designation}</Typography>
                    </Box>
                  </Box>
                </Col>
              ))}
          </Row>
        </Container>
        <SingleTeamInfoModal open={open} handleClose={handleClose} info={selectedMember} />
      </Box>
    </>
  )
}

export default ManagementTeam;
